/**
 * Chat / Title / File / Models API スキーマ
 */
import { z } from 'zod';
import { ModelSelectionSchema, ProviderInfoSchema, ReasoningModeSchema } from './base-schemas';
// ========================================
// Chat
// ========================================
/**
 * チャットコンテンツパート
 */
export const ChatContentPartSchema = z.discriminatedUnion('type', [
    z.object({ type: z.literal('text'), text: z.string() }),
    z.object({
        type: z.literal('image'),
        source: z.object({
            type: z.literal('base64'),
            media_type: z.string(),
            data: z.string(),
        }),
    }),
    z.object({
        type: z.literal('file'),
        data: z.string(),
        mediaType: z.string(),
        filename: z.string().optional(),
    }),
]);
/**
 * チャットメッセージ
 */
export const ChatMessageSchema = z.object({
    role: z.enum(['user', 'assistant', 'system', 'tool']),
    content: z.union([z.string(), z.array(ChatContentPartSchema)]),
    toolCallId: z.string().optional(),
    toolName: z.string().optional(),
});
/**
 * POST /chat リクエスト
 */
export const ChatRequestSchema = z.object({
    messages: z.array(ChatMessageSchema).min(1),
    model: ModelSelectionSchema,
    systemPrompt: z.string().optional(),
    tools: z
        .array(z.object({
        name: z.string(),
        description: z.string(),
        parameters: z.record(z.unknown()),
    }))
        .optional(),
    reasoningMode: ReasoningModeSchema.optional(),
    userEmail: z.string().optional(),
    temperature: z.number().min(0).max(1).optional(),
});
// ========================================
// Title
// ========================================
/**
 * POST /title リクエスト
 */
export const TitleGenerateRequestSchema = z.object({
    messages: z
        .array(z.object({
        role: z.enum(['user', 'assistant']),
        content: z.string(),
    }))
        .min(1, 'messages array must not be empty'),
    model: ModelSelectionSchema.optional(),
});
/**
 * POST /title レスポンス
 */
export const TitleGenerateResponseSchema = z.object({ title: z.string() });
// ========================================
// File
// ========================================
/**
 * POST /files/upload-url リクエスト
 */
export const FileUploadUrlRequestSchema = z.object({
    fileName: z.string().min(1, 'fileName is required'),
    mimeType: z.string().min(1, 'mimeType is required'),
    size: z.number({ required_error: 'size is required' }),
});
/**
 * POST /files/upload-url レスポンス
 */
export const FileUploadUrlResponseSchema = z.object({ uploadUrl: z.string(), s3Key: z.string() });
/**
 * GET /files/download-url レスポンス
 */
export const FileDownloadUrlResponseSchema = z.object({ downloadUrl: z.string() });
// ========================================
// Models
// ========================================
/**
 * GET /models レスポンス
 */
export const ModelsResponseSchema = z.object({
    providers: z.array(ProviderInfoSchema),
});
//# sourceMappingURL=chat-schemas.js.map